module.exports = __webpack_public_path__ + "static/media/crossIconLight.2a37823e.svg";